import { Configuration } from "./configuration";

// Initialize with defaults, will be updated by initializeApiAdapter
export const AXIOS_CONFIG = new Configuration({
    basePath: "https://api.heypharmacist.com", // Default fallback
    baseOptions: {
        timeout: 60000,
    },
});
